import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class SessionService {

  loginChange: Subject<boolean>;
  admLoginStatus: Subject<boolean>;
  sessionChange: Subject<string>;
  constructor() {
    this.loginChange = new Subject<boolean>();
    this.admLoginStatus = new Subject<boolean>();
    this.sessionChange = new Subject<string>();
  }
  clear() {
    sessionStorage.clear();
    this.loginChange.next(false);
    this.admLoginStatus.next(false);
  }

  getToken(): string {
    return sessionStorage.getItem('auth-token');
  }

  setToken(token: string) {
    sessionStorage.setItem('auth-token', token);
  }

  setSession(cookie: string) {
    sessionStorage.setItem('cookies', cookie);
    this.sessionChange.next(cookie);
  }

  set SessionCryptKey(enc_pad: string) {
    sessionStorage.setItem('enc_pad', enc_pad);
  }

  get SessionCryptKey() {
    return sessionStorage.getItem('enc_pad');
  }

  getSession(): string {
    return sessionStorage.getItem('cookies');
  }

  setAgentLogin(result: boolean) {
    sessionStorage.setItem('agent-login', String(result));
    this.loginChange.next(result);
  }

  getAgentLogin(): boolean {
    const result = sessionStorage.getItem('agent-login');
    if (result === undefined) {
      return false;
    } else {
      return Boolean(result);
    }
  }

  setAdminLogin(result: boolean) {
    sessionStorage.setItem('admin-login', String(result));
    this.admLoginStatus.next(result);
  }


  getAdminLogin(): boolean {
    const result = sessionStorage.getItem('admin-login');
    if (result === undefined) {
      return false;
    } else {
      return Boolean(result);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/session.service.ts